<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="项目名称">
            <el-select
              v-model="data.ClientCode"
              placeholder="请选择"
              style="width: 100%"
              :disabled="isDisabled"
            >
              <el-option
                v-for="item in ClientCodeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上级目录" prop="Extend1">
            <el-select
              v-model="data.Extend1"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in SysConfigArr"
                :key="item.SysId"
                :label="item.SysName"
                :value="item.SysId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目录键名" prop="SysCode">
            <el-input v-model="data.SysCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="目录名称" prop="SysName">
            <el-input v-model="data.SysName" clearable></el-input>
          </el-form-item>
          <el-form-item label="配置描述" prop="Description">
            <el-input
              v-model="data.Description"
              type="textarea"
              :autosize="{ minRows: 2 }"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm()">保存</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
export default {
  name: "UniformSysConfigInfo",
  props: {
    query: {
      default: () => ({}),
      type: Object,
    },
    SysConfigArr: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      data: {
        SysCode: "",
        SysName: "",
        Description: "",
        Extend1: "",
        UKeyName: "",
        ClientCode: "",
      },
      rules: {
        SysCode: [
          { required: true, message: "请输入子系统编号", trigger: "blur" },
        ],
        ClientCode: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
        SysName: [
          { required: true, message: "请输入子系统名称", trigger: "blur" },
        ],
      },
      isDisabled: false,
      ClientCodeArr: [
        {
          value: "BasicSystem",
          label: "基准配置",
        },
        {
          value: ZJApp.ZJUser.current.Departments[0].OrgId,
          label: ZJApp.ZJUser.current.Departments[0].OrgName,
        },
      ],
    };
  },
  created() {
    // this.data = this.query.SelectedSys;
    // debugger;
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    "query.SelectedSys": {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        (this.data = {
          SysCode: "",
          SysName: "",
          Description: "",
          Extend1: "",
          ClientCode: "",
        }),
          this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.query.SelectedSys && this.query.type == "add") {
        this.data.Extend1 = this.query.SelectedSys.SysId;
        this.data.ClientCode = this.query.SelectedSys.ClientCode;
      } else {
        this.data = this.query.SelectedSys;
      }
      if (this.data.ClientCode != "" && this.data.ClientCode != null) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    OnConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", false);
    },
    saveData() {
      let uuid = "";
      if (this.query.type == "edit") {
        uuid = this.query.SelectedSys.SysId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.query.type == "edit") {
        //编辑
        this.data.Creater = this.query.SelectedSys.Creater;
        this.data.CreateTime = this.query.SelectedSys.CreateTime;
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        this.data.Validity = 1;
        this.data.ClientVersion = "Alpha";
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.UniformSysConfigApi()
          .UpdateConfigSys(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "子系统配置修改";
            this.logInfo.LogMessage = r
              ? "子系统配置修改成功"
              : "子系统配置修改失败";
            this.logInfo.ModuleName = "配置管理";
            this.logInfo.PageName = "子系统配置详情";
            this.addOperationLog();
            this.$emit("clickCancel", r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          ClientVersion: "Alpha", //默认alpha版本，兼容基准数据
          SysId: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.UniformSysConfigApi()
          .AddConfigSys(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "子系统配置添加";
            this.logInfo.LogMessage = r
              ? "子系统配置添加成功"
              : "子系统配置添加失败";
            this.logInfo.ModuleName = "配置管理";
            this.logInfo.PageName = "子系统配置详情";
            this.addOperationLog();
            this.$emit("clickCancel", r);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>

<style></style>
